import { render, staticRenderFns } from "./OrdersImportDialog.vue?vue&type=template&id=cfb865d0"
import script from "./OrdersImportDialog.vue?vue&type=script&lang=js"
export * from "./OrdersImportDialog.vue?vue&type=script&lang=js"
import style0 from "./OrdersImportDialog.vue?vue&type=style&index=0&id=cfb865d0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports